import React from "react";
import type { LucideIcon } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";

export interface SupportCardProps {
    icon: LucideIcon;
    title: string;
    emphasis: string;
    description: string;
}

const SupportCard: React.FC<SupportCardProps> = ({ icon: Icon, title, emphasis, description }) => (
    <Card variant="outline" className="rounded-3xl border-transparent bg-card/95">
        <CardHeader>
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
                <Icon className="h-5 w-5 text-primary" aria-hidden />
            </div>
        </CardHeader>
        <CardContent>
            <CardTitle className="text-sm font-bold text-foreground">{title}</CardTitle>
            <p className="mt-0.5 text-xl font-extrabold text-primary">{emphasis}</p>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{description}</p>
        </CardContent>
    </Card>
);

export default SupportCard;
